import { render, staticRenderFns } from "./TextInputConfig.vue?vue&type=template&id=056fef8a&"
import script from "./TextInputConfig.vue?vue&type=script&lang=js&"
export * from "./TextInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports